<!-- 知识库-发布库 -->
<template>
  <el-row :gutter="15">
    <el-col :span="24" :lg="6">
      <el-card class="wiki-part">
        <div class="clearfix mb-10">
          <div class="pull-right" style="width: 40px">
            <el-button
              class="d-iblock ma-0"
              type="primary"
              size="small"
              title="新建顶层文章分类"
              style="margin-left: 0"
              @click="onAddWikicat"
              :disabled="!getPermission()"
            >
              <i class="fas fa-fw fa-plus" aria-hidden="true" />
            </el-button>
          </div>
          <div style="margin-right: 45px">
            <el-input
              v-model="filterText"
              placeholder="请输入关键字"
              style="width: 100%"
            ></el-input>
          </div>
        </div>

        <el-tree
          ref="wikicatTree"
          :data="wikicatList"
          :props="defaultProps"
          :filter-node-method="filterNode"
          :highlight-current="true"
          :expand-on-click-node="false"
          :default-expanded-keys="expandedKeys"
          :current-node-key="currentKey"
          :render-content="onRenderContent"
          class="filter-tree"
          node-key="ID"
          @node-click="clickNode"
        ></el-tree>
      </el-card>
    </el-col>

    <el-col :span="24" :lg="18">
      <el-card>
        <div class="clearfix mb-10">
          <div class="pull-left">
            <el-button
              type="primary"
              size="small"
              @click="onAddItem"
              :disabled="getCreate()"
            >
              <i class="fas fa-fw fa-plus-circle" aria-hidden="true" /> 新建文章
            </el-button>
            &nbsp;
            <span style="font-size: small; color: #409eff">{{
              indexName
            }}</span>
          </div>
          <div class="pull-right">
            <el-select
              v-model="former.WikicatID"
              clearable
              filterable
              placeholder="请选择文章分类"
              style="width: 200px"
            >
              <el-option
                v-for="(c, index) in wikicatSelectList"
                :key="index"
                :label="c.Title"
                :value="c.ID"
                :style="{ marginLeft: 15 * c.space + 'px' }"
              ></el-option>
            </el-select>
            &nbsp;
            <el-input
              v-model.trim="former.key"
              placeholder="请输入关键字"
              @keydown.enter.native="onSubmitQuery"
              style="width: 150px"
            >
            </el-input
            >&nbsp;
            <el-select
              v-model="former.tags"
              multiple
              collapse-tags
              :clearable="true"
              placeholder="请选择标签"
              filterable
              style="width: 150px"
            >
              <el-option
                v-for="(tag, index) in tagList"
                :key="index"
                :label="tag"
                :value="tag"
              ></el-option> </el-select
            >&nbsp;
            <el-button size="small" type="primary" @click="onSubmitQuery">
              <i class="fas fa-fw fa-search" />
            </el-button>
          </div>
        </div>
        <el-table :data="itemList" v-loading="loading" tooltip-effect="light">
          <el-table-column
            type="index"
            :index="pager.size * (pager.page - 1) + 1"
            :width="
              Math.max(48, (pager.size * pager.page).toString().length * 12)
            "
          />
          <el-table-column prop="Title" label="文章标题">
            <template slot-scope="{ row }">
              {{ row.Title }}
              <el-tooltip
                content="Top center"
                placement="top"
                effect="light"
                v-if="row.StickedAt"
              >
                <div slot="content">
                  置顶时间:{{ $sys.dateFormat(new Date(row.StickedAt)) }}
                </div>
                <i
                  class="fa fa-thumbs-up"
                  style="color: #e6a23c; cursor: pointer"
                ></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column label="标签" width="100">
            <template slot-scope="{ row }">
              <el-tag
                v-for="tag in row.Tags"
                :key="tag"
                style="margin-right: 5px; color: #00b3ca"
                >{{ tag }}</el-tag
              >
            </template>
          </el-table-column>
          <el-table-column label="创建人" prop="CreatedUser.Name" width="80" />
          <el-table-column label="创建日期" width="90">
            <template slot-scope="{ row }">
              <span v-if="row.CreatedAt">{{
                $sys.dateFormat(row.CreatedAt, "Y-m-d")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="PublishedUser.Name"
            label="发布人"
            width="80"
          />
          <el-table-column prop="PublishedAt" label="发布日期" width="90">
            <template slot-scope="{ row }">
              <span v-if="row.PublishedAt">{{
                $sys.dateFormat(row.PublishedAt, "Y-m-d")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="所属分类" prop="Wikicat.Title" width="150">
            <template slot-scope="{ row }">
              <el-tag>{{ row.Wikicat.Title }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column width="150" label="操作">
            <template slot-scope="scope">
              <el-button title="查看" @click.stop="onShowDetail(scope.row)">
                <i class="fas fa-fw fa-eye" />
              </el-button>
              <el-button
                type="primary"
                @click.stop="onEditItem(scope.row)"
                title="编辑"
                :disabled="getDisable(scope.row)"
              >
                <i class="fas fa-fw fa-edit"></i>
              </el-button>
              <el-button
                type="danger"
                @click.stop="onDeleteItem(scope.row)"
                title="删除"
                :disabled="getDisable(scope.row)"
              >
                <i class="fas fa-trash-alt"></i>
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="pull-right clearfix mar-top-10">
          <el-pagination
            @current-change="onChangePage"
            layout="total, prev, pager, next"
            :total="pager.total"
            :current-page="pager.page"
            :page-size="pager.size"
          ></el-pagination>
        </div>
      </el-card>
    </el-col>

    <el-dialog
      :title="(wikicatData.ID ? '编辑' : '新建') + '文章分类'"
      :visible.sync="wikicatEditing"
      :close-on-click-modal="false"
      width="600px"
      top="5vh"
      @open="onOpen"
      @close="onClose"
    >
      <el-form
        ref="wikicatDataForm"
        :model="wikicatData"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="上级分类名称" prop="ParentID">
          <!--当前点击的就是默认新建了上级名称-->
          <el-select
            v-model="wikicatData.ParentID"
            :clearable="false"
            placeholder="请选择上级"
            style="width: 100%"
          >
            <el-option
              v-for="(c, index) in wikicatSelectList"
              :key="index"
              :label="c.Title"
              :value="c.ID"
              :style="{ marginLeft: 15 * c.space + 'px' }"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="文章分类名称" prop="Title">
          <el-input
            v-model.trim="wikicatData.Title"
            placeholder="请输入分类名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="排序值" prop="Sort">
          <el-input-number
            v-model="wikicatData.Sort"
            :min="0"
            style="width: 100%"
          ></el-input-number>
        </el-form-item>
      </el-form>
      <div class="text-muted">注：上级名称为0则视为根目录。</div>
      <div slot="footer" class="dialog-footer">
        <el-button
          v-if="wikicatData.ID"
          class="pull-left"
          type="danger"
          @click="removeWikicat(wikicatData)"
        >
          <i class="fas fa-fw fa-trash"></i> 删 除
        </el-button>
        <el-button @click="wikicatEditing = false">
          <i class="fas fa-fw fa-times" aria-hidden="true"></i> 取 消
        </el-button>
        <el-button
          :disabled="wikicatSubmitDisable || !wikicatData.Title"
          type="primary"
          @click="operateWikicat"
        >
          <i class="far fa-fw fa-save" aria-hidden="true"></i> 确 定
        </el-button>
      </div>
    </el-dialog>

    <item-form
      v-model="item"
      :visible.sync="itemVisible"
      :tag-list="tagList"
      @form:saved="flush"
    />
    <item-detail :value="item" :visible.sync="seeingVisible" />
  </el-row>
</template>

<script>
import ItemForm from "./index--form.vue";
import ItemDetail from "../wikiDraft/view-detail.vue";

export default {
  components: {
    ItemForm,
    ItemDetail,
  },
  data() {
    return {
      group: 0, //业务组类型 0.嵌入式 1.工控
      //===================左边树===================
      isParent: false, // 是不是父级的分类
      wikicatEditing: false,
      wikicatData: this.getEmptyWikicat(), //文章分类信息
      filterText: "", //检索文章分类
      wikicatList: [], //树的数据源，只有根节点，子节点在根节点children中
      defaultProps: {
        label: "Title",
        children: "Children",
      },
      expandedKeys: [], //id
      currentKey: "",
      indexName: "",
      wikicatActiveData: {}, //当前选中的节点信息
      lastKeyHighlight: "", // 最终要高亮的值，以前高亮之后再拉数据没有关系，现在不行了，只能先拉数据再高亮
      wikicatSubmitDisable: false,
      wikicatSelectList: [], //文章分类选择列表，所有节点列表
      spanceNum: 0,
      rules: {
        Title: [
          {
            required: true,
            message: "文章分类名称不能为空",
            trigger: "change, blur",
          },
          {
            max: 200,
            message: "文章分类名称不能超过200个字符",
            trigger: "change, blur",
          },
        ],
        Sort: [{ required: true, message: "排序值不能为空", trigger: "blur" }],
      },
      treePager: {
        total: 0,
        page: 1,
        size: -1,
      },

      //===================右边列表===================
      itemList: [],
      loading: false,
      pager: {
        total: 0,
        page: 1,
        size: 15,
      },
      former: {
        WikicatID: "", //所属文章分类
        Status: 2, //状态 0:草稿.1:待审核.2:发布
        key: "",
        tags: [],
      },
      item: {},
      itemVisible: false,
      seeingVisible: false,
      typeList: {
        1: "文档", // 除了下面两种情况暂时都认为是文档
        2: "图片", // .jpg, .jpeg, .png, .gif
        3: "压缩包", // .zip, .rar
      },
      url: "",
      tagList: [],
    };
  },
  created() {
    this.group = this.$route.meta.group;
    this.getWikicatTree();
    this.getTagList();
  },
  watch: {
    filterText(val) {
      this.wikicatActiveData = {};
      this.expandedKeys = [];
      this.indexName = "";
      this.former.WikicatID = "";
      this.itemList = [];

      this.$refs.wikicatTree.filter(val);
    },
  },
  methods: {
    //===================左边树===================
    //获取文章分类树
    getWikicatTree() {
      this.wikicatList = [];
      this.wikicatSelectList = [];
      this.$axios
        .get(this.group === 0 ? "dci/wikicat/publish" : "ipc/wikicat/publish", {
          params: {
            where: {
              BusinessGroup: this.group,
            },
            return_tree: 1,
            ...this.treePager,
          },
        })
        .then((response) => {
          response.data.forEach((ele) => {
            this.spanceNum = 0;
            this.getChild(ele);
          });
          this.wikicatList = response.data; //树数据源,只有根节点+children

          if (!this.wikicatActiveData.ID) {
            this.wikicatActiveData = response.data[0];
            this.indexName =
              response.data[0].IndexName === ""
                ? ""
                : "<<" + response.data[0].IndexName;
            this.former.WikicatID = this.wikicatActiveData.ID;
            this.onSubmitQuery();
            this.expandedKeys = [response.data[0].ID];
            this.lastKeyHighlight = response.data[0].ID;
          }
          this.setCurrentKeySelf(this.lastKeyHighlight);
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    // 递归获取,因为不知道children有多少层
    getChild(item) {
      const data = item;
      this.spanceNum = 0;
      this.getSpanceNum(data);
      data.space = this.spanceNum;
      if (!data.Children) {
        data.Children = [];
      }
      this.wikicatSelectList.push(data);
      data.Children.forEach((childItem) => {
        this.getChild(childItem);
      });
    },
    // 计算这个之前有多少个父结点，就要显示多少个空格
    getSpanceNum(item) {
      if (item.ParentID !== 0) {
        this.spanceNum++;
        this.getSpanceNum(
          this.wikicatSelectList[
            _.findIndex(this.wikicatSelectList, (c) => c.ID === item.ParentID)
          ]
        );
      }
    },
    // //获取文章分类列表
    // getWikicatList() {
    //   const params = {
    //     return_list: 1,
    //   };
    //   this.$axios
    //     .get(this.group === 0 ? "dci/wikicat/publish" : "ipc/wikicat/publish", {
    //       params,
    //     })
    //     .then((response) => {
    //       this.wikicatList = response.data.data;
    //     })
    //     .catch(({ response }) => {
    //       this.$sys.alarmResponse(response);
    //     })
    //     .finally(() => {});
    // },
    //新建顶层文章分类
    onAddWikicat() {
      this.isParent = true;
      this.wikicatData = this.getEmptyWikicat();
      this.wikicatEditing = true;
    },
    //清空文章分类信息
    getEmptyWikicat() {
      return {
        Title: "", //文章分类
        ParentID: 0,
        Sort: 0, //排序
        BusinessGroup: this.group, //业务组类型 0.嵌入式 1.工控
      };
    },
    // 对树节点进行筛选时执行的方法，返回 true 表示这个节点可以显示
    filterNode(value, data) {
      return data.Title.includes(value);
    },
    //点击树节点
    clickNode(data) {
      this.wikicatActiveData = data;
      this.expandedKeys = [data.ID];
      this.indexName = data.IndexName === "" ? "" : "<<" + data.IndexName;
      this.former.WikicatID = data.ID;

      this.onSubmitQuery();
    },
    onOpen() {
      // if (this.wikicatList.length === 0) {
      //   this.getWikicatList();
      // }
    },
    onClose() {
      this.wikicatEditing = false;
      this.wikicatSubmitDisable = false;
      this.$refs.wikicatDataForm.resetFields();
      this.wikicatData = this.getEmptyWikicat();
    },
    // 在节点中添加自定义内容，即添加，编辑，删除,功能按钮
    onRenderContent(h, { node, data }) {
      if (this.getPermission()) {
        if (data.ID === 0) {
          //根节点
          return (
            <div class="show-node">
              <span>
                <span title={data.Title}>{data.Title}</span>
              </span>
            </div>
          );
        }
        return (
          <div class="show-node">
            <span>
              <span title={data.Title}>{data.Title}</span>
            </span>
            <span class="adjust-btn">
              {
                <el-button
                  class="pr-10"
                  type="text"
                  title="添加"
                  onClick={(event) => this.onTypeCreate(event, data)}
                >
                  <i class="fas fa-fw fa-plus"></i>
                </el-button>
              }
              {
                <el-button
                  type="text"
                  title="编辑"
                  onClick={(event) => this.onTypeEdit(node, event, data)}
                >
                  <i class="fas fa-fw fa-edit"></i>
                </el-button>
              }
            </span>
          </div>
        );
      } else {
        return (
          <div class="show-node">
            <span>
              <span title={data.Title}>{data.Title}</span>
            </span>
          </div>
        );
      }
    },
    // 添加父/子级分类
    onTypeCreate(event, data) {
      if (event) {
        // 阻止事件冒泡
        event.stopPropagation();
      }
      // 如果有值，表示添加的不是父级的分类
      if (data) {
        this.isParent = false;
        this.wikicatData.ParentID = data.ID;
        this.wikicatActiveData = data;
      } else {
        this.isParent = true;
      }
      this.wikicatData.BusinessGroup = this.group;
      this.lastKeyHighlight = data.ID;
      this.wikicatEditing = true;
    },
    // 编辑分类
    onTypeEdit(node, event, data) {
      if (event) {
        // 阻止事件冒泡
        event.stopPropagation();
      }
      // 当前节点点击数据
      this.wikicatData = { ...data };
      // 如果不是Null，表示添加的不是父级的分类
      if (data.ParentID !== 0) {
        this.isParent = false;
      } else {
        this.isParent = true;
      }
      this.wikicatActiveData = data;
      this.wikicatEditing = true;
    },
    // 删除分类
    removeWikicat(data) {
      this.$confirm("是否删除该文章分类？", "请确定", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() =>
          this.$axios.delete(
            this.group === 0
              ? `dci/wikicat/publish/${data.ID}`
              : `ipc/wikicat/publish/${data.ID}`
          )
        )
        .then(() => {
          this.wikicatEditing = false;

          if (this.former.WikicatID === data.ID) {
            this.wikicatActiveData = {};
            this.expandedKeys = [];
            this.former.WikicatID = "";
            this.indexName = "";
            this.itemList = [];
          }
          this.filterText = "";
          this.getWikicatTree();
          this.$message.success("删除成功");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },
    // 分类的新增和编辑操作
    operateWikicat() {
      this.$refs.wikicatDataForm.validate((valid) => {
        if (!valid) {
          return;
        }
        this.wikicatSubmitDisable = true;
        this.$axios
          .request({
            url: this.wikicatData.ID
              ? this.group === 0
                ? `dci/wikicat/publish/${this.wikicatData.ID}`
                : `ipc/wikicat/publish/${this.wikicatData.ID}`
              : this.group === 0
              ? "dci/wikicat/publish"
              : "ipc/wikicat/publish",
            method: this.wikicatData.ID ? "put" : "post",
            data: this.wikicatData,
          })
          .then(() => {
            this.$message.success(
              this.wikicatData.ID ? "成功更新文章分类" : "成功新增文章分类"
            );
            // this.getWikicatList();
            this.filterText = "";
            this.getWikicatTree();
          })
          .catch(({ response }) => {
            this.$sys.alarmResponse(response);
          })
          .finally(() => {
            this.wikicatEditing = false;
            this.wikicatSubmitDisable = false;
          });
      });
    },
    // 手动设置currentKey
    setCurrentKeySelf(data) {
      this.$nextTick(() => {
        this.$refs.wikicatTree.setCurrentKey(data);
      });
    },

    //===================右边列表===================
    getPermission() {
      var havePermission = false;
      if (this.$store.state.Auth.user.Permissions) {
        this.$store.state.Auth.user.Permissions.forEach((perm) => {
          if (
            "dci_wiki_publish_manage-*" === perm.Obj + "-" + perm.Act ||
            "dci_wiki_publish-POST" === perm.Obj + "-" + perm.Act
          ) {
            havePermission = true;
          }
        });
      }
      return havePermission;
    },
    getCreate() {
      var isdisable = true;
      isdisable = !this.getPermission();
      if (this.former.WikicatID === "") {
        isdisable = true;
      }
      return isdisable
    },
    getDisable(row) {
      //仅发布人可编辑、删除自己的文章
      var isdisable = true;
      if (this.$store.state.Auth.user.Permissions) {
        this.$store.state.Auth.user.Permissions.forEach((perm) => {
          if ("dci_wiki_publish_manage-*" === perm.Obj + "-" + perm.Act) {
            isdisable = false;
          }
        });
      }
      if (isdisable) {
        this.curUserID = this.$store.state.Auth.user.ID;
        isdisable = this.curUserID !== row.PublishedUserID;
      }
      return isdisable;
    },
    flush() {
      this.getItemList();
      this.getTagList();
    },
    getTagList() {
      this.$axios
        .get(this.group === 0 ? "dci/wiki/tag" : "ipc/wiki/tag", {
          params: {
            BusinessGroup: this.group,
            Status: this.former.Status,
          },
        })
        .then((response) => {
          this.tagList = response.data;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getItemList() {
      this.loading = true;
      this.$axios
        .get(this.group === 0 ? "dci/wiki/publish" : "ipc/wiki/publish", {
          params: {
            where: {
              BusinessGroup: this.group,
              WikicatID: this.former.WikicatID,
              Status: this.former.Status,
            },
            key: this.former.key,
            tags: this.former.tags,
            ...this.pager,
            with: ["CreatedUser", "PublishedUser", "Wikicat"],
            order: ["-sticked_at", "-published_at", "-created_at"],
          },
        })
        .then((response) => {
          this.itemList = response.data.data;
          this.pager = _.pick(response.data, "size", "page", "total");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    onSubmitQuery() {
      if (this.former.WikicatID !== "") {
        // this.wikicatActiveData = this.former.WikicatID;
        this.expandedKeys = [this.former.WikicatID];

        // 应该把它的父级节点都找到打开
        this.getParent(
          this.wikicatSelectList[
            _.findIndex(
              this.wikicatSelectList,
              (c) => c.ID === this.former.WikicatID
            )
          ]
        );

        this.lastKeyHighlight = this.former.WikicatID;
        this.setCurrentKeySelf(this.lastKeyHighlight);
      } else if (this.former.WikicatID === "") {
        this.wikicatActiveData = {};
        this.lastKeyHighlight = null;
        this.setCurrentKeySelf(this.lastKeyHighlight);
      }
      this.pager.page = 1;
      this.getItemList();
    },
    getParent(data) {
      // 追加父级节点id
      this.expandedKeys.push(data.ID);
      if (data.ParentID !== 0) {
        this.getParent(
          this.wikicatSelectList[
            _.findIndex(this.wikicatSelectList, (c) => c.ID === data.ParentID)
          ]
        );
      }
    },
    onChangePage(page) {
      this.pager.page = page;
      this.getItemList();
    },
    //点击查看按钮
    onShowDetail(row) {
      this.item = row;
      this.seeingVisible = true;
    },
    //新增文章
    onAddItem() {
      this.item = this.getEmptyItem();
      this.item.WikicatID = this.former.WikicatID;
      this.itemVisible = true;
    },
    //点击编辑按钮
    onEditItem(row) {
      // 因为列表不带正文内容
      this.$axios
        .get(this.group === 0 ? `dci/wiki/${row.ID}` : `ipc/wiki/${row.ID}`)
        .then((res) => {
          this.item = res.data;
          this.itemVisible = true;
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        })
        .finally(() => {});
    },
    getEmptyItem() {
      return {
        Title: "", //文章标题
        WikicatID: 0, //分类id
        PublishedAt: new Date(), //发布日期
        StickedAt: null, //置顶时间
        Content: "", //文章内容
        Attachments: [], //附件
        Tags: [], //标签
        VideoAddress: [""], //视频地址
        Status: 2, //状态 0:草稿.1:待审核.2:发布
        BusinessGroup: this.group, //业务组类型 0.嵌入式 1.工控
      };
    },
    onDeleteItem(row) {
      this.$confirm("确定要删除此文章吗？", "提示")
        .then(() =>
          this.$axios.delete(
            this.group === 0
              ? `dci/wiki/publish/${row.ID}`
              : `ipc/wiki/publish/${row.ID}`
          )
        )
        .then(() => {
          this.getItemList();
          this.$message.success("成功删除文章");
        })
        .catch(({ response }) => {
          this.$sys.alarmResponse(response);
        });
    },

    onSuccess() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.success("复制失败");
    },
  },
};
</script>

<style lang="scss">
.wiki-part {
  .el-tree-node__content {
    position: relative;
  }
  .show-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-right: 8px;
    font-size: 14px;
    padding-top: 5px;
  }
  .adjust-btn {
    display: none;
    position: absolute;
    right: 15px;
  }
  .show-node:hover .adjust-btn {
    display: block;
  }
  .adjust-btn .el-button {
    margin: 0;
  }
}
.d-iblock {
  display: inline-block;
}
.standard-search {
  margin-right: 0.5em;
  .el-select {
    .el-input .el-input__inner {
      height: 28px !important;
    }
    .el-select__tags,
    .el-select__tags span {
      white-space: nowrap;
      overflow: hidden;
      flex-wrap: nowrap;
    }
  }
  vertical-align: middle;
}
</style>
